module.exports = __webpack_public_path__ + "static/img/battery.c6513e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/battery.png
// module id = DXyQ
// module chunks = 0